import { render, staticRenderFns } from "./BadgeRole.vue?vue&type=template&id=5aa03c1a"
import script from "./BadgeRole.vue?vue&type=script&lang=js"
export * from "./BadgeRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports